/** @format */

import React, { FC, useState } from 'react'
import styled from 'styled-components'
import { _$, Card, BreadcrumbItem } from '@king-design/react'
import { useParams } from 'react-router'
import dayjs from 'dayjs'
import MonitorCrumb from 'src/components/MonitorCrumb'
import RegionBtn from 'src/components/RegionBtn'
import { MonitorSearch } from 'src/components'
import QuickRangeDate from 'src/components/QuickRangeDate'
import { DateTimeProps } from 'src/containers/MonitorHistoryTactics/constants'
import EventList from 'src/containers/MonitorHistoryTactics/AlarmEventList'

const AlarmEventDetail: FC<any> = ({ className }) => {
  const { policyName } = useParams<{ policyName: string }>()
  const [region, setRegion] = useState<string>(localStorage.getItem('systemId'))
  const [dateTime, setDateTime] = useState<DateTimeProps>({
    StartTime: dayjs().subtract(1, 'h').unix(),
    EndTime: dayjs().unix()
  })
  const [query, setQuery] = useState<string>('')

  return (
    <div className={className}>
      <MonitorCrumb
        breadArr={[
          { title: _$('告警服务') },
          { title: _$('告警历史'), route: '/monitor/alarmServer/history/home' }
        ]}
      >
        <BreadcrumbItem>{decodeURIComponent(policyName)}</BreadcrumbItem>
      </MonitorCrumb>
      <Card className="MonitorAlarmTactics">
        <RegionBtn
          defaultValue={region}
          regionChange={value => {
            setRegion(value)
          }}
        />
        <div className="header">
          <QuickRangeDate
            format="YYYY-MM-DD HH:mm"
            // eslint-disable-next-line no-restricted-syntax -- QuickRangeDate 与组件约定的默认范围
            defautlValue={'近1小时'}
            // eslint-disable-next-line no-restricted-syntax -- QuickRangeDate 与组件约定的默认范围
            quickRange={['近1小时', '近1天', '近3天', '近1周']}
            optionalDateRange={30}
            changeValue={date => {
              setDateTime({
                StartTime: dayjs(date[0]).unix(),
                EndTime: dayjs(date[1]).unix()
              })
            }}
          />
          <MonitorSearch
            placeholder={_$('输入实例ID')}
            value={query}
            onChange={value => {
              setQuery(value)
            }}
          />
        </div>
        <EventList
          region={region}
          dateTime={dateTime}
          query={query}
          policyName={decodeURIComponent(policyName)}
        />
      </Card>
    </div>
  )
}

export default styled(AlarmEventDetail)`
  padding: 0 16px;
  .header {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    & > * {
      margin-top: 16px;
    }
    .k-select {
      margin-right: 16px;
    }
  }
`
